import { Button, Group, Select, Stack, Textarea } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { useForm } from '@mantine/form';
import dayjs from 'dayjs';
import { tKeys, useTranslation } from 'locales';

type Reason = { id: number; name: string };

type DirectContactPauseNoteValues = {
  reason_id: string;
  end_at?: string;
  comment?: string;
};

type DirectContactPauseNoteProps = {
  reasons: Array<Reason>;
  onSubmit: (values: DirectContactPauseNoteValues) => void;
};

const DEFAULT_PAUSE_DAYS = 7;

export const DirectContactPauseNote = ({ reasons, onSubmit }: DirectContactPauseNoteProps) => {
  const { t } = useTranslation();

  const form = useForm<{ reasonId: string; endAt: string; comment: string }>({
    initialValues: {
      reasonId: '',
      endAt: dayjs().add(DEFAULT_PAUSE_DAYS, 'day').toISOString(),
      comment: '',
    },
    validate: {
      reasonId: value => (value.length === 0 ? t(tKeys.ERROR.FIELD_REQUIRED) : null),
    },
  });

  const handleSubmit = form.onSubmit(values =>
    onSubmit({
      reason_id: values.reasonId,
      end_at: values.endAt || undefined,
      comment: values.comment.trim() || undefined,
    }),
  );

  return (
    <form onSubmit={handleSubmit}>
      <Stack gap="sm">
        <Select
          label={t(tKeys.FORM.REASON)}
          data={reasons.map(reason => ({ value: String(reason.id), label: reason.name }))}
          {...form.getInputProps('reasonId')}
        />
        <DateInput
          label={t(tKeys.FORM.END_DATE)}
          clearable
          minDate={dayjs().add(1, 'day').toDate()}
          valueFormat="DD/MM/YYYY"
          {...form.getInputProps('endAt')}
        />
        <Textarea
          label={t(tKeys.COMMENT)}
          autosize
          minRows={3}
          {...form.getInputProps('comment')}
        />
        <Group justify="flex-end">
          <Button type="submit">{t(tKeys.CONFIRM)}</Button>
        </Group>
      </Stack>
    </form>
  );
};
